var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M28 14C28 6.26808 21.7319 0 14 0C6.26808 0 0 6.26808 0 14C0 20.5654 4.52032 26.0747 10.6182 27.5878V18.2784H7.73136V14H10.6182V12.1565C10.6182 7.39144 12.7747 5.1828 17.453 5.1828C18.34 5.1828 19.8705 5.35696 20.4966 5.53056V9.40856C20.1662 9.37384 19.5922 9.35648 18.8793 9.35648C16.5838 9.35648 15.6968 10.2262 15.6968 12.4869V14H20.2698L19.4841 18.2784H15.6968V27.8975C22.629 27.0603 28.0006 21.1579 28.0006 14H28Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M19.4837 18.2783L20.2694 13.9999H15.6964V12.4868C15.6964 10.2261 16.5834 9.35642 18.8789 9.35642C19.5918 9.35642 20.1658 9.37378 20.4962 9.4085V5.5305C19.8701 5.35634 18.3396 5.18274 17.4526 5.18274C12.7743 5.18274 10.6178 7.39138 10.6178 12.1564V13.9999H7.73096V18.2783H10.6178V27.5878C11.7008 27.8566 12.8337 27.9999 13.9996 27.9999C14.5736 27.9999 15.1398 27.9647 15.6958 27.8975V18.2783H19.4831H19.4837Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9ac26d2bfaef2b60c6ae9f3f62efba1a.svg";
export { ForwardRef as ReactComponent };